import React from 'react';

import { Container } from './styles';

interface IContentGridProps {
  children: React.ReactNode;
}

const ContentGrid: React.FC<IContentGridProps> = ({children}) => {
  return (
    <Container>
      {children}
    </Container>
  );
}

export default ContentGrid;
